import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "@mui/material";
import { cloneElement } from "react";
import styles from './Settings.module.scss';
import CloseMenuIcon from '../../assets/closeDesktop.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import stylesContacts from '../Contacts/Contacts.module.scss';
const dialogStyle = styles.listStyle;
export const ConfirmComponent = ({ confirmFunc, handleClose, text }) => {
    const { t } = useTypedTranslation();
    return (_jsxs("div", { className: styles.confirm, children: [_jsx("div", { className: styles.text, children: _jsx("span", { children: text }) }), _jsxs("div", { className: styles.buttons, children: [_jsx("button", { onClick: confirmFunc, children: t("yes") }), _jsx("button", { onClick: handleClose, children: t("no") })] })] }));
};
export const NotFoundChat = ({ confirmFunc, user }) => {
    const { t } = useTypedTranslation();
    const typeChat = () => {
        if (user)
            return t('notFoundUser');
        return t('notFoundChannel');
    };
    return (_jsxs("div", { className: styles.confirm, children: [_jsx("div", { className: styles.text, children: _jsx("span", { children: typeChat() }) }), _jsx("div", { className: styles.buttons, children: _jsx("button", { onClick: confirmFunc, children: t("yes") }) })] }));
};
export const LayoutDialogList = ({ children }) => {
    return (_jsx("div", { style: { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', marginBottom: '4px', height: '100%' }, children: _jsx("ul", { className: stylesContacts.list, style: { display: 'flex', flexDirection: 'column', overflow: 'auto', marginBottom: '4px' }, children: children }) }));
};
const DialogComponent = ({ children, onClose, isOpen, isMinimized }) => {
    const handleClose = (e) => {
        e.stopPropagation();
        onClose(false);
    };
    return (_jsxs(Dialog, { onClose: handleClose, open: isOpen, classes: { paper: dialogStyle }, sx: { display: isMinimized ? 'none' : 'block' }, children: [_jsx("div", { className: styles.close, children: _jsx(CloseMenuIcon, { cursor: 'pointer', fontSize: '1.3rem', onClick: handleClose }) }), cloneElement(children, { handleClose })] }));
};
export default DialogComponent;
